function handleGridList() {
    $("#goList").length && $("body").on(clickEv, "#goList", function() {
        $(this).parent().find("li").removeClass("active"), $(this).addClass("active"), $("#sandBox .element").addClass("full_width"), $("#sandBox .element").removeClass("no_full_width"), $("#sandBox .element .row-left").addClass("col-sm-4"), $("#sandBox .element .row-right").addClass("col-sm-8"), $("#sandBox .element").removeClass("animated flipInX"), $("#sandBox .element").addClass("velit-animated")
    }), $("#goGrid").length && $("body").on(clickEv, "#goGrid", function() {
        $(this).parent().find("li").removeClass("active"), $(this).addClass("active"), $("#sandBox .element").removeClass("full_width"), $("#sandBox .element").addClass("no_full_width"), $("#sandBox .element .row-left").removeClass("col-sm-4"), $("#sandBox .element .row-right").removeClass("col-sm-8")
    })
}

function HandleCarousel() {
    $(".related-products ul.related-products-items").length && $(".related-products ul.related-products-items").owlCarousel({
        navigation: !0,
        pagination: !1,
        items: 4,
        slideSpeed: 200,
        paginationSpeed: 800,
        rewindSpeed: 1e3,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [979, 3],
        itemsTablet: [768, 3],
        itemsTabletSmall: [540, 2],
        itemsMobile: [360, 1],
        navigationText: ['<i class="fa fa-angle-left" title="Previous" data-toggle="tooltip" data-placement="top"></i>', '<i class="fa fa-angle-right" title="Next" data-toggle="tooltip" data-placement="top"></i>']
    }), $("#gallery-images-mobile .vertical-slider").length && $("#gallery-images-mobile .vertical-slider").owlCarousel({
        navigation: !0,
        pagination: !1,
        items: 4,
        slideSpeed: 200,
        paginationSpeed: 800,
        rewindSpeed: 1e3,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [979, 4],
        itemsTablet: [768, 4],
        itemsTabletSmall: [540, 4],
        itemsMobile: [360, 4],
        navigationText: ['<i class="fa fa-angle-left" title="Previous" data-toggle="tooltip" data-placement="top"></i>', '<i class="fa fa-angle-right" title="Next" data-toggle="tooltip" data-placement="top"></i>']
    }), $("#gallery-images .vertical-slider").bxSlider({
        mode: "vertical",
        slideWidth: 150,
        minSlides: 3,
        nextText: '<i class="fa fa-angle-up" title="Previous" data-toggle="tooltip" data-placement="top"></i>',
        prevText: '<i class="fa fa-angle-down" title="Next" data-toggle="tooltip" data-placement="top"></i>',
        hideControlOnEnd: !0,
        infiniteLoop: !1,
        pager: !1,
        slideMargin: 0
    })
}

$(window).ready(function($) { 
  handleGridList();
  HandleCarousel();
});
